import { defineStore } from "pinia";
import type ConfigurationFileContents from "@/interfaces/Configuration/ConfigurationFileContents";

function createEmptyConfigurationContents(): ConfigurationFileContents {
  return {
    publicApiKey: "",
    publicApiBaseUrl: "",
    customerPortalKey: "",
    contentManagementSystemBaseUrl: "",
    portalThemeVariables: {},
    runtimeSource: "env-fallback",
  };
}

export const useConfigurationStore = defineStore("configuration", {
  state: () => ({
    configurationContents: createEmptyConfigurationContents(),
  }),
  getters: {
    hasContentManagementSystem(state) {
      return state.configurationContents.contentManagementSystemBaseUrl !== "";
    },
  },
  actions: {
    setConfigurationContents(configurationContents: ConfigurationFileContents) {
      this.configurationContents = {
        ...configurationContents,
      };
    },
  },
});
